<div class="fab-container" [class.hidden]="!isFabVisible">
  <div
    class="fab d-flex align-items-center"
    type="button"
    aria-controls="dropdown-basic"
    aria-label="Toggle navigation"
    (click)="showSupportPhoneNumPopup()"
  >
    <ng-icon name="lucidePhone" class="text-white fs-5"></ng-icon>
  </div>
  <div
    class="popup p-3 d-flex flex-column align-items-center"
    [class.d-block]="isOpen"
    [class.d-none]="!isOpen"
    (appClickOutside)="onClickedOutside($event)"
  >
    <p>تماس با پشتیبانی</p>
    <a href="tel:+02191002372">02191002372</a>
  </div>
</div>
